                                                                      

const EVENTS_API_PATH = "/api/events";

const getEvents                             = async () => {
  return fetch(EVENTS_API_PATH).then((response) => response.json());
};

const getEventById                                = async (id) => {
  return fetch(`${EVENTS_API_PATH}?id=${id}`)
    .then((response) => response.json()                    )
    .then((events) => events[0]);
};

const getEventsByTag                                  = async (tag) => {
  return fetch(`${EVENTS_API_PATH}?tag=${encodeURIComponent(tag)}`).then((response) =>
    response.json(),
  );
};

export { getEvents, getEventById, getEventsByTag };
